import { userService } from "../services";
import config from "../config/config";
import { decryptAesObj } from "../components/CommonComponents/AESencryptdecrypt";

export const siteAction = {
  getSiteList,
  geUserList,
  addSite,
  updateSite,
  addSubSite,
  getSite,
  getSiteById,
  updateSubSite,
  userActiveInactive,
  getUserbySiteId,
  addSiteV2,
  updateSiteEME,
  getconstituencyList,
  getSiteListById,
  getAllMastersData
};

const companyId = decryptAesObj(localStorage.getItem("data")).companyId;

async function getSiteList() {
  let url = `${config.baseUrl}v1/site_type/all`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}
async function getAllMastersData(url, payload) {
  const res = await userService.post(url, payload);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function geUserList() {
  let url = `${config.baseUrl}api/v1/user/all?companyId=${companyId}`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function addSite(payload, edit) {
  let formData = new FormData();
  formData.append("isActive", payload.switch);
  formData.append("name", payload.siteName);
  formData.append("siteTypeId", 1);
  formData.append("companyId", companyId);
  formData.append("parentSiteId", payload.emergency.id);
  formData.append("type", payload.type);

  let url = "";
  if (edit) {
    formData.append("id", edit);
    url = `${config.baseUrl}api/v2/site/update`;
  } else url = `${config.baseUrl}api/v3/site/add`;
  // const res = await userService.post(url, formData);
  // if (res && res.status === 200) return res.data;
  // else return null;
  const response = await userService.postFIle(url, formData);
  console.log(response);
  if (response && response.status == 200) {
    return response.data;
  } else {
    console.log(response);
    alert(response.data.message);

    return null;
  }
}

async function addSiteV2(payload) {
  let url = `${config.baseUrl}api/v2/site/add`;
  const response = await userService.postFIle(url, payload);
  console.log(response);
  if (response && response.status == 200) {
    return response.data;
  } else {
    console.log(response);
    if (response && response.data && response.data.message) {
      alert(response.data.message);
    } else {
      // alert('Something went Wrong');
    }

    return null;
  }
  // const res = await userService.post(url, payload);
  // if (res && res.status === 200) return res.data;
  // else return null;
}

async function updateSite(payload) {
  const url = `${config.baseUrl}api/v2/site/update`;
  const response = await userService.postFIle(url, payload);
  console.log(response, "sdfgvhbjnkml,");
  if (response && response.status === 200) {
    return response.data;
  } else {
    console.log(response);
    alert(response.data.message);

    // if (response.status != 500) {
    //     return response;
    //     // alert(response.data.responseDescription);
    // } else
    // if (response.status == 401) {
    //     alert(response.data.message);
    // } else {
    //     alert(response.data.responseDescription);
    //     // return (response);
    // }
    return null;
  }
  // if (res && res.status === 200) return res.data;
  // else return null;
}

async function updateSiteEME(payload) {
  const url = `${config.baseUrl}api/v3/site/eme/update`;
  const response = await userService.postFIle(url, payload);
  console.log(response);
  if (response && response.status == 200) {
    return response.data;
  } else {
    console.log(response);
    alert(response.data.message);

    return null;
  }
}

async function addSubSite(payload) {
  const url = `${config.baseUrl}api/v1/sub/site/add`;
  const res = await userService.postFIle(url, payload);

  if (res && res.status === 200) return res.data;
  else return null;
}
// hii yash
async function getSite(payload) {
  let url = `${config.baseUrl}api/v3/site/all?companyId=${
    payload.companyId
  }&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&search=${
    payload.search
  }&status=${payload.status}&siteTypeId=${payload.siteTypeId}&userId=${
    decryptAesObj(localStorage.getItem("data")).id
  }&notFetchEmergencies=${payload.notFetchEmergencies}&type=${
    payload.type ? payload.type : ""
  }&fetchCordinates=${payload.fetchCordinates}&zoneId=${
    payload.zoneId ? payload.zoneId : ""
  }`;
  const res = await userService.get(url, payload);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function getconstituencyList(payload) {
  let url = `${config.baseUrl}api/v1/get/all/constituency?companyId=${
    payload.companyId
  }&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&userId=${
    decryptAesObj(localStorage.getItem("data")).id
  }`;
  const res = await userService.get(url, payload);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function getSiteById(id) {
  let url = `${config.baseUrl}api/v2/site?companyId=${
    decryptAesObj(localStorage.getItem("data")).companyId
  }&id=${id}`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function getSiteListById(id) {
  let url = `${config.baseUrl}api/v3/site?companyId=${
    decryptAesObj(localStorage.getItem("data")).companyId
  }&id=${id}`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function updateSubSite(payload) {
  const url = `${config.baseUrl}api/v2/sub/site/update`;
  const res = await userService.postFIle(url, payload);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function userActiveInactive(payload) {
  const url = `${config.baseUrl}api/v1/site/active/inactive?siteId=${payload.siteId}&status=${payload.status}`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}

async function getUserbySiteId(id) {
  const url = `${config.baseUrl}api/v1/user/by/site?siteId=${id}`;
  const res = await userService.get(url);

  if (res && res.status === 200) return res.data;
  else return null;
}
